// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"866":"d87f1654","3334":"9d8a5b86","4666":"dc8b1945","6305":"4721831e"}[chunkId] + ".css";
};